import { DocumentsListBrokerageFirmModule } from '@folio/modules';

import { StepperFooter, useStepperContext } from '@korint/folio';
import { useQuery } from '@tanstack/react-query';
import { configControllerGetPublicTenantConfigQueryOptions } from 'korint-sdk';

export function BrokerageFirmDocuments() {
  const stepper = useStepperContext();

  const { data: brokerageFirmDocumentsList = [] } = useQuery({
    ...configControllerGetPublicTenantConfigQueryOptions(),
    select: data => data.brokerageFirmDocuments?.brokerageFirmDocumentsList,
  });

  return (
    <div className="flex flex-col gap-4">
      <DocumentsListBrokerageFirmModule
        title="Liste des documents à signer"
        documentsList={brokerageFirmDocumentsList}
      />
      <StepperFooter
        nextButtonEnabled={true}
        onNext={async () => {
          stepper.next();
        }}
      />
    </div>
  );
}
